module.exports = __webpack_public_path__ + "img/epiImage.ab704f51.svg";